<template>
  <el-dialog
    :visible="showDialog"
    width="464px"
    class="dialog-wrap"
    title=""
    @close="handleClose"
    :close-on-click-modal="false">
    <div class="wrapper flex flex-col flex-center">
      <img v-if="isCreate" src="../../assets/images/flow/ok.png" alt="" class="ok-icon">
      <span v-if="isCreate" class="success-text">创建成功</span>
      <span class="desc">顾客扫描收款单二维码，即可进行收款</span>
      <div class="code-wrapper flex flex-col flex-center">
        <p class="title">{{ receiptName }}</p>
        <p class="desc">{{ merchantName }}</p>
        <div class="code-bg flex flex-center justify-center">
          <div id="qr-code-img"></div>
        </div>
        <p class="sn">SN:{{ receiptOrderNo }}</p>
      </div>
    </div>
    <div slot="footer" style="text-align: center;">
      <el-button type="primary" class="bs-btn" @click="downloadQRCode">下载收款单收款码</el-button>
      <el-button type="primary" class="bs-btn2" @click="handleClose" v-if="isCreate">返回至收款单首页</el-button>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  name: "qrcode-dialog",
  data() {
    return {
      qrcodeImg: null,
      bgImg: new Image(),
    };
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
    receiptName: {
      type: String,
      default: '',
    },
    merchantName: {
      type: String,
      default: '',
    },
    receiptOrderNo: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.bgImg.src = require('../../assets/images/flow/download-qr-code.png');
  },
  watch: {
    showDialog(val) {
      // console.log(val);
      if (val) {
        this.createQRCode();
      }
    },
  },
  methods: {
    createQRCode() {
      setTimeout(() => {
        document.getElementById('qr-code-img').innerHTML = '';
        this.qrcodeImg = new QRCode(document.getElementById('qr-code-img'), {
          width: 212, // 设置宽高
          height: 212,
        });
        this.qrcodeImg.clear();
        const envObj = {
          test: 'https://t-sytls.lepass.cn/receipt/skd.do',
          pre: 'https://p-sytls.lepass.cn/receipt/skd.do',
          prd: 'https://sytls.leshuazf.com/receipt/skd.do',
        };
        const url = process.env.NODE_ENV === 'production' ? envObj[process.env.CUSTOM_ENV] : 'https://p-sytls.lepass.cn/receipt/skd.do';
        this.qrcodeImg.makeCode(`${url}?receiptOrderNo=${this.receiptOrderNo}`);
      }, 50);
    },
    handleClose() {
      this.$emit('close');
    },
    downloadQRCode() {
      const canvas = document.createElement('canvas'); // 创建画布
      canvas.width = 668;
      canvas.height = 1000;
      const ctx = canvas.getContext('2d');
      const qrcodeImg = document.getElementById("qr-code-img").getElementsByTagName('img')[0]; // 获取二维码图片标签
      ctx.drawImage(this.bgImg, 0, 0, 668, 1000);
      ctx.drawImage(qrcodeImg, 149, 278, 372.76, 372.76);
      ctx.font = "40px NotoSansHans-Bold, NotoSansHans-Bold";
      ctx.fillStyle = "#ffffff";
      const nameWidth = ctx.measureText(this.receiptName).width;
      const nameX = 334 - (nameWidth / 2); // 334为canvas画布宽度一半
      ctx.fillText(this.receiptName, nameX, 156);
      ctx.font = "28px NotoSansHans-Regular, NotoSansHans-Regular";
      const locationeWidth = ctx.measureText(this.merchantName).width;
      const locationeX = 334 - (locationeWidth / 2); // 334为canvas画布宽度一半
      ctx.fillText(this.merchantName, locationeX, 207);
      ctx.font = "24px NotoSansHans-Regular, NotoSansHans-Regular";
      ctx.fillStyle = "#1895FF";
      const billCodeWidth = ctx.measureText(this.receiptOrderNo).width;
      const billCodeX = 334 - (billCodeWidth / 2); // 334为canvas画布宽度一半
      ctx.fillText(this.receiptOrderNo, billCodeX, 718);
      const tempUrl = canvas.toDataURL('image/png'); // 画布生成base64格式图片
      // 创建a标签，模拟点击下载
      const a = document.createElement('a');
      a.setAttribute('download', `${this.receiptOrderNo}${this.receiptName}.png`);
      a.style.display = 'none';
      a.href = tempUrl;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.$message.success('下载成功！');
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  .ok-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 16px;
  }

  .success-text {
    margin-bottom: 10px;
    font-size: 20px;
    color: #303133;
  }

  .desc {
    margin-bottom: 20px;
    font-size: 16px;
    color: #606266;
  }

  .code-wrapper {
    width: 380px;
    height: 432px;
    padding-top: 64px;
    margin-bottom: 20px;
    background-image: url(../../assets/images/flow/qr-code-bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .title {
      margin-bottom: 10px;
      font-size: 22px;
      font-weight: bold;
      color: #fff;
    }

    .desc {
      margin-bottom: 0;
      font-size: 14px;
      color: #fff;
    }

    .code-bg {
      width: 239px;
      height: 239px;
      margin-top: 26px;
      margin-bottom: 13px;
      background: #fff;
      border-radius: 11px;
      box-shadow: 0 2px 7px 0 rgba(29, 126, 255, 0.2);
    }

    .sn {
      font-size: 13px;
      color: #1895ff;
    }
  }
}
</style>
